import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { ResponseCode } from '@app/constants/Common';
import { alertMessage, showMessage } from '@app/constants/Messages';
import { pipelineOptionsToString, pipelineStringToOptions } from '@pages/dvtjcuv/common/PipelineUtil';
import { optionsToString } from '@app/utils/CommonUtils';
import { requestSaveDVTJCUVPipeline } from '@pages/dvtjcuv/service/DVTJCUVPipelineService';
import { updateContactPointDetail } from '@app/services/CandidateService';
import InputDiscussionWRecContent from '@pages/dvtjcuv/rundvtjcuv/connectcddemp/InputDiscussionWRecContent';

// Fields 248 / 248m persist to ContactPoint (separate endpoint) — never include them in the pipeline POST body.
const CONTACT_POINT_FIELD_KEYS = ['candidate_receive_request', 'cdd_receiver_category'];

const InputDiscussionWRecModal = (props) => {
    const { pipelineInfo, isShow, onClose } = props;
    const [pipeline, setPipeline] = useState({});
    const latestPipelineRef = useRef(null);
    const originalContactPointRef = useRef({ candidate_receive_request: '', cdd_receiver_category: '' });

    useEffect(() => {
        if (pipelineInfo) {
            const seed = { cdd_receiver_id: pipelineInfo.cdd_receiver_id || '' };
            setPipeline(pipelineStringToOptions(seed));
        } else {
            setPipeline({});
        }
        latestPipelineRef.current = null;
        originalContactPointRef.current = { candidate_receive_request: '', cdd_receiver_category: '' };
    }, [isShow, pipelineInfo]);

    const onChangeInputItem = (values, column) => {
        pipeline[column.key] = values;
    };

    const onLatestPipelineLoaded = (latest) => {
        latestPipelineRef.current = latest;
    };

    const onOriginalContactPointLoaded = (original) => {
        originalContactPointRef.current = original;
    };

    const buildPipelineBody = () => {
        const base = { ...(latestPipelineRef.current || {}) };
        const edited = pipelineOptionsToString(pipeline);
        CONTACT_POINT_FIELD_KEYS.forEach((k) => { delete edited[k]; delete base[k]; });
        return { ...base, ...edited, id: '' };
    };

    const buildContactPointBodyIfChanged = () => {
        const currentReceiveRequest = optionsToString(pipeline.candidate_receive_request, true);
        const currentCategory = optionsToString(pipeline.cdd_receiver_category, true);
        const original = originalContactPointRef.current;
        const changed = (currentReceiveRequest || '') !== (original.candidate_receive_request || '')
                     || (currentCategory || '') !== (original.cdd_receiver_category || '');
        if (!changed) return null;
        return {
            candidate_id: pipeline.cdd_receiver_id,
            contact_points: {
                candidate_receive_request: currentReceiveRequest,
                cdd_receiver_category: currentCategory,
            },
        };
    };

    const onSavePipeline = () => {
        if (!pipeline.cdd_receiver_id) {
            showMessage('Vui lòng nhập Cdd Receiver ID');
            return;
        }

        const pipelineBody = buildPipelineBody();
        const cpBody = buildContactPointBodyIfChanged();

        const calls = [requestSaveDVTJCUVPipeline(pipelineBody)];
        if (cpBody) {
            calls.push(updateContactPointDetail(cpBody));
        }

        Promise.all(calls)
            .then((responses) => {
                const fail = responses.find((r) => r?.sts_code !== ResponseCode.SUCCESS);
                if (fail) {
                    alertMessage(fail.sts_code);
                    return;
                }
                onClose(true);
            })
            .catch((error) => {
                console.log(`Error:${JSON.stringify(error)}`);
            });
    };

    return (
        <Modal show={isShow}
               fullscreen
               style={{ zIndex: 3002 }}
               onHide={() => onClose()}
               animation={false}>
            <Modal.Header>
                <Modal.Title>{'Discussion w Rec'}</Modal.Title>
                <Button variant='secondary' onClick={() => onClose()}>Close</Button>
            </Modal.Header>
            <form onSubmit={(event) => {
                event.preventDefault();
                onSavePipeline();
            }}>
                <Modal.Body>
                    <InputDiscussionWRecContent
                        pipeLineInfo={pipeline}
                        onChangeInputItem={onChangeInputItem}
                        onLatestPipelineLoaded={onLatestPipelineLoaded}
                        onOriginalContactPointLoaded={onOriginalContactPointLoaded}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button type='submit' className='btn btn-primary'>
                        <i className='fas fa-save mr-2' />
                        Save
                    </Button>
                </Modal.Footer>
            </form>
        </Modal>
    );
};

export default InputDiscussionWRecModal;
